import React, { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

import { ROUTE_PERSONAL_PURCHASE_PAGE } from "../../../routes";

import {
  closeAlert,
  showInfoAlert,
  showModalAlert,
} from "../../../redux/actions/alert/alertActions";

import SimCommentContainer from "../comment";
import SimInfoComponent from "../../../components/public/singleSimTabs/info/infoSection";
import SimSourcesComponent from "../../../components/public/singleSimTabs/info/sourcesSection";

import ButtonComponent from "../../../components/public/button";

import { SubsctibtionAlertText } from "./styledSimInfo";

const SimInfoTabContainer = ({
  simID,
  simInfoData,
  bookData,
  isLogin,
  isIframe,
}) => {
  const alertState = useSelector((state) => state.alert);
  const dispatch = useDispatch();
  const history = useHistory();

  const simIsFree =
    simInfoData?.singleSimDetail?.is_free &&
    simInfoData.singleSimDetail.is_free;
  const simIsSubscribed =
    simInfoData?.singleSimDetail?.is_subscribed &&
    simInfoData.singleSimDetail.is_subscribed;

  const handleCheckSimAccess = (e) => {
    if (e.target.name === "add-comment-btn") {
      if (isLogin) {
        return true;
      } else {
        dispatch(showInfoAlert("لطفا ابتدا وارد سایت شوید."));
        return false;
      }
    }
    if (alertState.isShow) {
      return dispatch(closeAlert());
    }

    if (
      (!isLogin && !simIsFree) ||
      (e.target.name === "add-comment-btn" && !isLogin)
    ) {
      dispatch(showInfoAlert("لطفا ابتدا وارد سایت شوید."));
      return false;
    }
    if (!isLogin && simIsFree) {
      dispatch(
        showInfoAlert(
          "لطفا ابتدا وارد سایت شوید و سپس از آزمایش‌های رایگان استفاده کنید."
        )
      );
      return false;
    }
    if (isLogin && !simIsFree && !simIsSubscribed) {
      dispatch(showModalAlert({ content: <ActivateSubsctibtionAlert /> }));
      return false;
    }

    return true;
  };

  const checkSimAccess = useCallback(
    (e) => {
      return handleCheckSimAccess(e);
    },
    [alertState.isShow, isLogin, simIsFree, simIsSubscribed]
  );

  const SubscriptionActivation = () => {
    history.push({
      pathname: ROUTE_PERSONAL_PURCHASE_PAGE,
      state: {
        simInfoData: simInfoData,
      },
    });
    dispatch(closeAlert());
  };

  const ActivateSubsctibtionAlert = () => {
    return (
      <div className="d-flex flex-column text-center py-4">
        <SubsctibtionAlertText className="mb-4">
          لطفا ابتدا اشتراک را فعالسازی کنید و سپس وارد آزمایش مربوطه شوید!
        </SubsctibtionAlertText>
        <ButtonComponent
          onClick={SubscriptionActivation}
          className="d-block mx-auto"
        >
          فعال‌سازی اشتراک
        </ButtonComponent>
      </div>
    );
  };

  return (
    <>
      <SimInfoComponent
        simInfoData={simInfoData}
        bookData={bookData}
        isLogin={isLogin}
        isIframe={isIframe}
        CheckAccessFunction={checkSimAccess}
      />
      <SimSourcesComponent simInfoData={simInfoData} />
      <SimCommentContainer
        simID={simID}
        isLogin={isLogin}
        CheckAccessFunction={checkSimAccess}
      />
    </>
  );
};

export default SimInfoTabContainer;
